import(/* webpackMode: "eager" */ "/app/app/dashboard/pricing/page.tsx");
